import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=2ca97392&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=2ca97392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca97392",
  null
  
)

export default component.exports